import { BIRTHDAY_FORMAT, OLD_BIRTHDAY_FORMAT, REGIONS } from './constant'
import { isString } from 'lodash'
import parse from 'date-fns/parse'
import isValid from 'date-fns/isValid'

const times = (num, str = '*') => {
  return new Array(num + 1).join(str)
}

export const encryptId = (id, type = 0) => {
  if (!isString(id) || !id) return ''
  if (id?.length <= 4) return times(4)
  if (type === 0) return id.substring(0, 2) + times(id.length - 4) + id.substr(id.length - 2)
  return id.substring(0, 4) + times(id.length - 4)
}

export const encryptPhone = (phone) => {
  if (!isString(phone) || !phone) return ''
  if (phone?.length <= 4) return times(4)
  return phone.substring(0, 2) + times(phone.length - 4) + phone.substr(phone.length - 2)
}

export const encryptEmail = (email) => {
  if (!isString(email) || !email) return ''
  let emailLocal = email?.split('@')[0]
  let emailDomain = email?.split('@')[1]
  if (emailLocal?.length <= 2) return times(2) + '@' + emailDomain
  return (
    emailLocal.substring(0, 1) +
    times(emailLocal.length - 2) +
    emailLocal.substr(emailLocal.length - 1) +
    '@' +
    emailDomain
  )
}

export const parseValid = (dateStr, formatStr = BIRTHDAY_FORMAT, date) => {
  const parseDate = parse(dateStr, formatStr, date)
  return isValid(parseDate) ? parseDate : parse(dateStr, OLD_BIRTHDAY_FORMAT, date)
}

export const formatDialingCode = (dialingCode) => `(+${dialingCode}) `

export const loadImage = (url, callback) => {
  let img = new Image()

  img.onload = () => {
    img.onload = null
    callback?.()
  }

  img.src = url
}

export const translateRegion = (region) => (REGIONS[region] ? REGIONS[region] : region)

export const getBirthDate = function (IDCard) {
  const year = IDCard.substring(6, 10)
  const month = IDCard.substring(10, 12)
  const day = IDCard.substring(12, 14)
  const birthDate = year + '/' + month + '/' + day
  return birthDate
}
